import {post, get} from '@/utils/request'

// 获取账单明细列表
export function getBillListAPI(data) {
    return post({
        data,
        url: ''
    })
}

// 详情-获取订单信息
export function getOrderInfoAPI(data) {
    return post({
        data,
        url: ''
    })
}

// 详情-获取支付信息
export function getPayInfoAPI(data) {
    return post({
        data,
        url: ''
    })
}

// 详情-获取分账信息
export function getSubAccountInfoAPI(data) {
    return post({
        data,
        url: ''
    })
}

// 详情-获取资金流水信息
export function getMoneyFlowInfoAPI(data) {
    return post({
        data,
        url: ''
    })
}

// // 详情-稽核冲账之前需要查询钱包余额
// export function getWalletBalanceAPI(data) {
//     return post({
//         data,
//         url: ''
//     })
// }

// // 详情-稽核冲账
// export function auditAccountAPI(data) {
//     return post({
//         data,
//         url: ''
//     })
// }
